import { FlexColumn, FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { ParagraphMedium } from 'baseui/typography';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import {
  ALARMS_REPORTS_PAGE,
  CONSUMPTION_REPORTS_PAGE,
  DELIVERY_REPORTS_PAGE,
  EVIDENCES_REPORTS_PAGE,
  PATHS_REPORTS_PAGE,
  REPORTS_PAGE,
} from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { pageState } from '../../storage/app';
import { canUpdateReportState, consumptionDateState, reportNameState, updateReportState } from '../../storage/reports';
import { StyledTooltip } from '../ui/StyledTooltip';
import AlarmsReportFilters from './filters/AlarmsReportFilters';
import ConsumptionReportFilters from './filters/ConsumptionReportFilters';
import DeliveryReportFilters from './filters/DeliveryReportFilters';
import EvidencesReportFilters from './filters/EvidencesReportFilters';
import PathsReportFilters from './filters/PathsReportFilters';
import SharedReportFilters from './filters/SharedReportFilters';

export function ReportTools() {
  const { theme, classes } = useStyles();
  const reportName = useRecoilValue(reportNameState);
  const page = useRecoilValue(pageState);
  const navigate = useNavigate();
  const resetConsumptionDate = useResetRecoilState(consumptionDateState);
  const setUpdateReport = useSetRecoilState(updateReportState);
  const canUpdateReport = useRecoilValue(canUpdateReportState);
  const isConsumptionReport = page === CONSUMPTION_REPORTS_PAGE.id;
  const isDeliveryReport = page === DELIVERY_REPORTS_PAGE.id;
  const isPathsReport = page === PATHS_REPORTS_PAGE.id;
  const showSharedFilters = !isConsumptionReport;
  const { id: workspaceId } = useParams();
  const redirectPath = workspaceId ? generatePath(REPORTS_PAGE.route, { id: workspaceId }) : '/';

  const onReload = () => {
    setUpdateReport((prev) => !prev);
  };

  const onClose = () => {
    resetConsumptionDate();
    navigate(redirectPath);
  };

  return (
    <FlexColumn gap={theme.sizing.scale400}>
      <FlexRow classNames={classes.centeredBetween}>
        <ParagraphMedium
          margin={0}
          style={{ fontWeight: '700', fontSize: '18px' }}
        >
          {reportName}
        </ParagraphMedium>
        <FlexRow gap={theme.sizing.scale200}>
          <StyledTooltip
            content="Recargar"
            showArrow={false}
          >
            <Button
              size="compact"
              shape="circle"
              onClick={onReload}
              kind="tertiary"
              disabled={!canUpdateReport}
            >
              <MaterialIcon
                name={'refresh'}
                size="mini"
                color={canUpdateReport ? undefined : theme.colors.contentStateDisabled}
              />
            </Button>
          </StyledTooltip>
          <StyledTooltip
            content="Cerrar reporte"
            showArrow={false}
          >
            <Button
              shape="circle"
              kind="tertiary"
              size="compact"
              onClick={onClose}
            >
              <MaterialIcon
                name="close"
                size="mini"
              />
            </Button>
          </StyledTooltip>
        </FlexRow>
      </FlexRow>
      <FlexColumn>
        {showSharedFilters && (
          <SharedReportFilters
            withTimeInterval={!isDeliveryReport}
            extraFilters={isDeliveryReport && <DeliveryReportFilters />}
            manualIntervalLabel={isPathsReport ? 'Captura manual' : undefined}
            extraManualFilters={isPathsReport && <PathsReportFilters />}
          />
        )}
        {page === EVIDENCES_REPORTS_PAGE.id && <EvidencesReportFilters />}
        {page === ALARMS_REPORTS_PAGE.id && <AlarmsReportFilters />}
        {isConsumptionReport && <ConsumptionReportFilters />}
      </FlexColumn>
    </FlexColumn>
  );
}
